import { buildTheme } from './utils'
import { ThemeOverride } from './default'

const darkTheme: ThemeOverride = {
  // coming soon
}

export default buildTheme(darkTheme)
